module.exports = __webpack_public_path__ + "img/icon_wa.1a70ea3d.svg";